import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "mbgfc-home-popup-dismissed"

export default class extends Controller {
  static values = { version: String }

  connect() {
    try {
      if (window.localStorage.getItem(STORAGE_KEY) === this.versionValue) return
    } catch {}

    this.element.showModal()
  }

  dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, this.versionValue)
    } catch {}

    this.close()
  }

  close() {
    this.element.close()
  }
}